import { createApp, Component, App } from 'vue'
// 引入状态管理
import store from '@/options/store'
// 引入element-plus依赖
import elementPlus from '@/plugins/elementPlus'
// 引入svg-sprite
import '@/assets/svg/svg.config'
import SvgIcon from '@/assets/svg/svg.vue'
// 悬浮框定位指令
import PositionPlugin from '@/plugins/positionPlugin'
// 创建app
const AppFactory = (options: Component): App => {
  const app = createApp(options)
  app.use(store).use(PositionPlugin).use(elementPlus)
  app.component('svg-icon', SvgIcon)
  return app
}
export { AppFactory }
